"use client";

import {memo} from "react";

import {useSnapshot} from "valtio";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons";
import {Typography} from "@/shared/ui/data-display/typography";

import type {SearchPageInstance} from "../search-page.model";

import "./styles/notice-empty.scss";

interface NoticeEmptyProps {
    pageModel: SearchPageInstance;
}

export const NoticeEmpty = memo(function NoticeEmpty({pageModel}: NoticeEmptyProps) {
    const snapshot = useSnapshot(pageModel);
    const {t} = useTranslation("search");

    return (
        <div className="notice-empty">
            <Typography size={32} weight={700} color="black" as="h3">
                {t("moreIsOutThere")}
            </Typography>

            <Typography size={16} lineHeight={150} color="paragraph" as="p">
                {t("noHomesMatch")}
            </Typography>

            <div className="notice-empty__actions">
                {snapshot.filters.dateFlexibility.hasValue && (
                    <ButtonBase onClick={pageModel.openCalendar.bind(pageModel)}>{t("changeDates")}</ButtonBase>
                )}

                {snapshot.filters.advancedFilters.hasValue && (
                    <ButtonBase variant="secondary" onClick={pageModel.clearAdvanceFilter.bind(pageModel)}>
                        {t("clearFilters")}
                    </ButtonBase>
                )}
            </div>
        </div>
    );
});
